/*
 * Developed by CQ Inversiones SAS.  Copyright (c) 2025. All rights reserved.
 * Desarrollado por CQ Inversiones SAS.  Copyright (c) 2025. Todos los derechos reservados.
 */

/*
 * Project:      mkad-frontend
 * Developed by: Juan David Pelaez Cumbe
 * Date:         28/04/25 - 13:44:44
 * Module name:  manage-session.service
 * File name:    manage-session.service.ts
 * IDE:          WebStorm
 */

import {Injectable} from '@angular/core';
import {MkadBaseService, URLS_SERVICE} from '@shared/services';
import {Observable} from 'rxjs';
import {ManageSessionResponseInterface} from '@shared/interface/main/manage-session.interface';

@Injectable({providedIn: 'root'})
export class ManageSessionService extends MkadBaseService {
  private readonly authUrl = URLS_SERVICE.auth;

  /**
   * @description
   * Method that starts the manage session
   */
  startManage(customer: number): Observable<ManageSessionResponseInterface> {
    return this.http.post<ManageSessionResponseInterface>(this.authUrl.base + this.authUrl.manage.base + this.authUrl.manage.start, {customer});
  }

  /**
   * @description
   * Method that ends the manage session
   */
  endManage() {
    return this.http.post<boolean>(this.authUrl.base + this.authUrl.manage.base + this.authUrl.manage.end);
  }
}
